<script setup lang="ts">
  import { ref, watch } from "vue"
  import sidebarItems from "./sidebarItems"
  const { status, data, signIn, signOut } = useSession()

  // Sidebar menu state
  const sidebarMenu = ref(sidebarItems)
</script>

<template>
  <div>
    <!-- Scrollable sidebar container -->
    <div class="scrollnavbar">
      
      <!-- User profile section -->
      <div class="profile">
        <div class="profile-pic">
          <v-avatar size="45">
            <img :src="data?.user?.image" width="50" alt="User avatar" />
          </v-avatar>
        </div>
        <div class="profile-name">
          <h5>{{ data?.user?.email || 'unknown' }}</h5>
        </div>
      </div>

      <!-- Sidebar navigation list -->
      <v-list class="pa-4">
        <!-- Menu loop -->
        <template v-for="(item, i) in sidebarMenu" :key="i">
          <!-- Single menu item -->
          <v-list-item :to="item.to" rounded="lg" class="mb-1">
            <template v-slot:prepend>
              <v-icon :icon="item.icon" />
            </template>
            <v-list-item-title v-text="item.title" />
          </v-list-item>
        </template>
      </v-list>
    </div>
  </div>
</template>